import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	knowMoreInfoText: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-app-sub-header.know-more-info-text',
		defaultMessage: 'View undelivered notifications in the last 21 days. ',
		description: 'Information text used in sub header about the page content',
	},
	learnMoreText: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-app-sub-header.learn-more-text',
		defaultMessage: 'Learn more about customer notification logs.',
		description: 'Text to show in learn more link button',
	},
});
